<!-- Page Title -->
<div class="page-title-area">
    <div class="d-table">
        <div class="d-table-cell">
            <div class="container">
                <div class="page-title-content text-white">
                    <h2>Faire un don</h2>
                    <ul class="text-gray-200">
                        <li><a routerLink="/" class="hover:underline">Accueil</a></li>
                        <li>Faire un don</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Contenu -->
<section class="py-20 bg-white">
    <div class="container mx-auto px-4 max-w-4xl">
        <div class="mb-10">
            <h2 class="text-3xl font-bold text-gray-800 mb-4">Chères donatrices, chers donateurs,</h2>
            <p class="text-gray-700 mb-4">
                L'<strong>ASESA</strong> (Association Aide pour la Santé, l'Éducation et le Sport en Afrique)
                est engagée depuis sa création aux côtés des communautés, notamment dans les zones rurales
                défavorisées du Togo, pour améliorer la santé, renforcer l'éducation, promouvoir l'hygiène
                et soutenir le sport.
            </p>
            <p class="text-gray-700 mb-4">
                Grâce à votre soutien, nous pouvons continuer à agir concrètement sur le terrain
                et apporter une aide durable aux populations qui en ont le plus besoin.
                Pour votre générosité, nous vous disons : <strong>Merci !</strong>
            </p>
        </div>

        <!-- Appel aux dons -->
        <div class="bg-green-100 p-6 rounded-xl shadow-md mb-10">
            <h3 class="text-2xl font-semibold text-green-800 mb-4">Appel aux dons</h3>
            <p class="text-gray-800 mb-3">
                L'<strong>ASESA</strong> soutient la construction de centres de santé, d'écoles, de puits
                ainsi que la formation et l'éducation des enfants, des jeunes et des femmes en Afrique.
            </p>
            <p class="text-gray-800 mb-4">
                Si vous croyez qu'un développement durable est possible grâce à une aide directe sur le terrain,
                rejoignez-nous. <strong>Chaque don compte.</strong>
            </p>

            <div class="bg-white border rounded-lg p-4">
                <h4 class="font-bold mb-3">Coordonnées bancaires pour les dons</h4>
                <p><strong>Bénéficiaire :</strong> ASSOCIATION AIDE POUR LA SANTE L'EDUCATION ET LE SPORT EN AFRIQUE</p>
                <p><strong>Adresse :</strong> MORETAN, RUE OKPOGUEDJE, COMMUNE EST-MONO – S/C 225-BP19 ELAVAGNON – LOMÉ</p>
                <hr class="my-3">
                <p><strong>Code BIC :</strong> <em>BSAHTGTG</em></p>
                <p><strong>Code banque :</strong> <em>TG133</em></p>
                <p><strong>Code guichet :</strong> <em>01006</em></p>
                <p><strong>Numéro de compte :</strong> <em>00300142364</em></p>
                <p><strong>Clé RIB :</strong> <em>93</em></p>
                <p><strong>Clé IBAN :</strong> <em>42</em></p>
                <p><strong>Domiciliation :</strong> <em>Lomé Siège</em></p>
                <p class="mt-2"><strong>IBAN :</strong> <em class="text-green-800">TG53 TG13 3010 0600 0300 1423 6493</em></p>
            </div>
        </div>

        <!-- Adresse de contact -->
        <div class="text-sm text-gray-600">
            <p><strong>ASESA – Association Aide pour la Santé, l'Éducation et le Sport en Afrique</strong><br>
                Morétan, Rue Okpoguédjé<br>
                Commune Est-Mono<br>
                Lomé, Togo</p>
            <p><strong>E-Mail :</strong> <a href="mailto:Asesatogo25@gmail.com" class="text-blue-600">Asesatogo25&#64;gmail.com</a></p>
        </div>
    </div>
</section>

<!-- Abonnement newsletter -->
<app-subscribe></app-subscribe>
